/**
 * Scrolls the page view to a specific position based on configuration options.
 *
 * @param {Object} [options] - Optional configuration for scrolling behavior.
 * @param {boolean} [options.scrollBothStrips=false] - Whether to scroll considering both header and strips container.
 * @param {boolean} [options.dynamicScrollPlp=false] - Whether to dynamically scroll to a specific product page.
 * @returns {Promise<void>} A promise that resolves when scrolling is complete.
 * @description
 * This function handles different scrolling scenarios:
 * 1. Scrolls to header height by default
 * 2. Can scroll to strips container height if scrollBothStrips is true
 * 3. Can dynamically scroll to a specific product tile if dynamicScrollPlp is true
 *
 * @example
 * // Scroll to default header height
 * await scrollIntoPageView();
 *
 * @example
 * // Scroll with both strips and dynamic product page scroll
 * await scrollIntoPageView({
 *   scrollBothStrips: true,
 *   dynamicScrollPlp: true
 * });
 */
export const scrollIntoPageView = async (options?: {
  scrollBothStrips: boolean
  dynamicScrollPlp: boolean
}) => {
  const headerMonogram = document.getElementById('header-monogram')
  const scrollYVal = localStorage.getItem('scrollYVal')
    ? JSON.parse(localStorage.getItem('scrollYVal') || '')
    : 0

  if (headerMonogram) {
    nextTick(() => {
      let headerHeight = headerMonogram?.clientHeight

      const stripsContainer = document.getElementById('strips-container')
      if (stripsContainer && options?.scrollBothStrips) {
        headerHeight = stripsContainer?.clientHeight
      }

      //TODO: (tracked #1217) gotta find a better way to handle the double requestAnimationFrame
      // https://github.com/vuejs/vue/issues/9200#issuecomment-468512304
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          if (
            scrollYVal?.scroll &&
            options?.dynamicScrollPlp &&
            scrollYVal?.prodPage
          ) {
            const productTileId = `${scrollYVal?.scroll}`
            let element = document.getElementById(productTileId)
            if (element) {
              nextTick(() => {
                element = document.getElementById(productTileId)
                if (element) {
                  element.scrollIntoView({
                    behavior: 'smooth',
                    block: 'start',
                  })
                }
              })
            } else {
              window.scrollTo({
                top: 0,
                behavior: 'smooth',
              })
            }
          } else {
            window.scrollTo({
              top: headerHeight,
              behavior: 'smooth',
            })
          }
        })
      })
    })
  }
}
